import { render, staticRenderFns } from "./NutrientRequirementCorrection.vue?vue&type=template&id=17f21b29&scoped=true&lang=html&"
import script from "./NutrientRequirementCorrection.vue?vue&type=script&lang=js&"
export * from "./NutrientRequirementCorrection.vue?vue&type=script&lang=js&"
import style0 from "./NutrientRequirementCorrection.vue?vue&type=style&index=0&id=17f21b29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f21b29",
  null
  
)

export default component.exports